// Romanian
export default {
  newVersionAvailable: 'Versiune nouă disponibilă',
  versionInfo:
    'O nouă versiune a {appName} este disponibilă. Reîncărcați pagina pentru a actualiza la versiunea {version}.',
  reload: 'Reîncarcă',
  later: 'Mai târziu',
  intl_addr_country: 'Țară',
  intl_addr_address1: 'Adresă',
  intl_addr_address2: 'Adresă 2',
  intl_addr_address3: 'Adresă 3',
  intl_addr_address4: 'Adresă 4',
  intl_addr_city: 'Oraș',
  intl_addr_state: 'Județ',
  intl_addr_zipCode: 'Cod poștal',
  intl_addr_longitude: 'Longitudine',
  intl_addr_latitude: 'Latitudine',
  intl_addr_department: 'Departament',
  intl_addr_suburb: 'Suburbie',
  intl_addr_postalCode: 'Cod poștal',
  intl_addr_province: 'Provincie',
  intl_addr_neighborhood: 'Cartier',
};
